;
namespace Sintra {

	const _uids: Array<string> = [];

	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}

	function getFreeUid() {
		var uid;
		do {
			uid = s4() + s4();
		} while (_uids.indexOf(uid) >= 0);
		return uid;
	}


	export type TemplateSource = string | HTMLTemplateElement | HTMLElement;

	export type DynamicObject = {[name: string]: any};

	export type TypedValueObject<TKey extends string | number, TValue> = {
		[name in TKey]: TValue;
	};

	export type MapEntry<TKey, TValue> = [TKey, TValue];



	export abstract class WebComponent {

		public static applyTemplate(templateElement: HTMLElement, destination: HTMLElement) {
			let elementToClone: HTMLElement | DocumentFragment = templateElement;
			if (templateElement instanceof HTMLTemplateElement) {
				elementToClone = templateElement.content;
			}
			const templateClone = elementToClone.cloneNode(true);
			destination.innerHTML = "";
			destination.appendChild(templateClone);	

			return destination;
		}

		public static resolveTemplate(templateSource: TemplateSource) {

			if (!templateSource || templateSource === "") {
                return null;
            }

			if (typeof templateSource === "string") {
                if (templateSource.charAt(0) === "@") {
					// TODO find by name @.....
                    throw new Error("not implemented");
                } else {
					
					// assume si tratti di una stinga contenente codice html
					var parser = new DOMParser();
                	let doc = parser.parseFromString(templateSource, 'text/html');
					// reimposta template source 
					templateSource = doc.querySelector("template");

                    if (!templateSource) {
                        throw new Error("unresolved template resource, invalid html code");
                    }
                }
            }
			
			if (templateSource instanceof HTMLTemplateElement) {
				const templateClone = templateSource.content.cloneNode(true);
				return templateClone as HTMLElement;
			}
			else {
				console.log("invalid template type");
				return null;
			}
		}


		private _htmlElement: HTMLElement;
		private _templateSource: TemplateSource;
		private _templateRoot: HTMLElement;

		constructor(htmlElement: HTMLElement | string, template?: TemplateSource) {

			if (typeof htmlElement === "string") {
				htmlElement = document.createElement(htmlElement);
			}
			this._htmlElement = htmlElement;

			this.uid = getFreeUid();
			this._htmlElement.setAttribute("uid", this.uid);

			this._templateSource = template;
			this._onTemplateSourceChanged();
		}


		private _onTemplateSourceChanged() {
			if (this._templateSource) {
				const resolvedTemplate = WebComponent.resolveTemplate(this._templateSource);
				if (resolvedTemplate) {
					this._templateRoot = WebComponent.applyTemplate(resolvedTemplate, this._htmlElement);
					this.onApplyTemplate(this._templateRoot);
				}
			}
		}


		// virtual
		protected onApplyTemplate(templateRoot: HTMLElement) { }

		protected getTemplatePart<TElement extends HTMLElement>(partName: string) {
			return this.htmlElement.querySelector(`[template-part="${partName}"]`) as TElement;
		}


		public readonly uid: string;

		public get htmlElement() { return this._htmlElement; }

		public get template() { return this._templateSource; }
		public set template(v: TemplateSource) { 
			if (this._templateSource !== v) {
				this._templateSource = v;
				this._onTemplateSourceChanged();
			}
		}
	}
}